@if (isGiveLink()) {
  <!-- GiveLink Header: "You are giving to [fundName]" -->
  <div class="form-header form-header--givelink">
    <p class="givelink-intro">{{ 'contribute.you_are_giving_to' | translateLang }}</p>
    @if (!isLoading()) {
      <h1 class="givelink-fund-name">{{ fundName() }}</h1>
    } @else {
      <!-- Loading state while fund info is being fetched -->
      <div class="givelink-fund-name-skeleton"></div>
    }
  </div>
} @else if (isDefault()) {
  <!-- Default Header: "Charity Fund Finder" -->
  <div class="form-header">
    <h1 class="form-title">{{ title() | translateLang }}</h1>
    <p class="form-subtitle">{{ subtitle() | translateLang }}</p>
  </div>
} @else if (isAuth()) {
  <!-- Auth Header: title/subtitle + projected fund-switcher -->
  <div class="form-header form-header--auth">
    <div class="form-header__auth-content">
      <h1 class="form-title">{{ title() | translateLang }}</h1>
      <p class="form-subtitle">{{ subtitle() | translateLang }}</p>
    </div>
    <ng-content />
  </div>
}
